module.exports = __webpack_public_path__ + "static/media/Resume.4eb70221.pdf";